export const validateFullName = value => {
  return value && value.length > 0 && value.trim().split(" ").length > 1;
};
